import * as React from "react";
import usePaginationQueryParameter from "hooks/usePaginationQueryParameter";
const withPaginationQueryParameter = (Component, obj) => function WrappedComponent(props) {
  const result = usePaginationQueryParameter(obj == null ? void 0 : obj.pageSizes);
  return /* @__PURE__ */ React.createElement(Component, { ...props, paginationQueryParameter: result });
};
export default withPaginationQueryParameter;
